export const EVERY_3_DAYS = "EVERY_3_DAYS";
export const EVERY_5_DAYS = "EVERY_5_DAYS";
export const EVERY_7_DAYS = "EVERY_7_DAYS";
export const ONE_TIME = "ONE_TIME";
